



























































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {FreightService, Lading} from "@/interfaces/entity";
import {LadingStore} from "@/modules/ladings/store";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {IdMapper} from "@/interfaces/state/base";
import moment from "moment";
import EnumLabel from "@/shared/components/EnumSelector/components/Label.vue";
import {LadingPaymentType, LadingPickupType} from "@/enums/type";
import {FORMAT_DATE_PICKER} from "@/shared/constant";

@Component({
  name: "DetailLadingPrint",
  components: {EnumLabel}
})
export default class extends mixins(CommonMixin) {
  @Prop({required: true})
  readonly ladingId!: string;
  LadingPaymentType = LadingPaymentType;
  LadingPickupType = LadingPickupType;
  moment = moment;
  FORMAT_DATE_PICKER = FORMAT_DATE_PICKER;

  get lading(): Lading {
    return LadingStore.data[this.ladingId];
  }

  get freightServiceData(): IdMapper<FreightService> {
    return FreightServiceStore.data;
  }

  get totalMoney() {
    if (this.lading?.payment === LadingPaymentType.Receiver) {
      return (this.lading?.codMoney || 0) + this.lading?.totalFee;
    } else if (this.lading?.payment === LadingPaymentType.Cash) {
      return this.lading?.codMoney || 0;
    }
    return 0;
  }
}
